import React from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  Paper,
  useTheme
} from "@mui/material";

const EtapaSolicitacoes = ({
  requestTypes,
  handleTipoChange,
  handleSubtipoChange,
  handleAddTipo,
  handleRemoveTipo,
  handleAddSubtipo,
  handleRemoveSubtipo,
  onGenerateRequestTypes,
  isGenerating = false,
  errorMessage,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%"}}>
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
        🧾 Tipos de Solicitação
      </Typography>

      <Typography variant="body1" gutterBottom>
        Aqui você define como as solicitações dos seus clientes serão organizadas. Isso ajuda na triagem e automação do atendimento.
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Você pode gerar sugestões de tipos com ajuda da IA ou começar do zero e cadastrar manualmente.
      </Typography>

      {errorMessage && (
        <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, border: `1px solid ${theme.palette.warning.light}`, backgroundColor: theme.palette.warning.light + "22" }}>
          <Typography variant="body2" color="warning.main">
            {errorMessage}
          </Typography>
        </Box>
      )}

      {requestTypes.length === 0 && (
        <Box sx={{ mb: 3, display: "flex", flexWrap: "wrap", gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={isGenerating}
            onClick={onGenerateRequestTypes}
          >
            {isGenerating ? "Gerando sugestões..." : "Gerar sugestões com IA"}
          </Button>
          <Button variant="outlined" onClick={handleAddTipo}>
            Cadastrar primeiro tipo manualmente
          </Button>
        </Box>
      )}

      {requestTypes.map((request, tipoIndex) => (
        <Paper key={tipoIndex} sx={{ mb: 3, p: 2, borderLeft: `5px solid ${theme.palette.primary.main}` }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Tipo de Solicitação"
                value={request.tipo}
                onChange={(e) => handleTipoChange(tipoIndex, e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} textAlign="right">
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleRemoveTipo(tipoIndex)}
                disabled={requestTypes.length <= 1}
              >
                Remover
              </Button>
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Subtipos:
          </Typography>

          {request.subtipos.map((subtipo, subtipoIndex) => (
            <Grid container spacing={2} alignItems="center" key={subtipoIndex} mb={1}>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  label={`Subtipo ${subtipoIndex + 1}`}
                  value={subtipo}
                  onChange={(e) => handleSubtipoChange(tipoIndex, subtipoIndex, e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => handleRemoveSubtipo(tipoIndex, subtipoIndex)}
                  disabled={request.subtipos.length <= 1}
                >
                  Remover
                </Button>
              </Grid>
            </Grid>
          ))}

          <Button variant="outlined" onClick={() => handleAddSubtipo(tipoIndex)}>
            Adicionar Subtipo
          </Button>
        </Paper>
      ))}

      {requestTypes.length > 0 && (
        <Box mt={2}>
          <Button variant="contained" onClick={handleAddTipo}>
            Adicionar Novo Tipo
          </Button>
        </Box>
      )}

      <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: "block" }}>
        💡 Essas categorias são úteis para relatórios, bots e atendimentos automatizados.
      </Typography>
    </Box>
  );
};

export default EtapaSolicitacoes;